export default __webpack_public_path__ + "static/media/snake.11a6d1a0.png";